const parseJsonString = (value) => {
  if (typeof value !== "string") return null
  const trimmed = value.trim()
  if (!trimmed.startsWith("{") || !trimmed.endsWith("}")) return null
  try {
    return JSON.parse(trimmed)
  } catch (_) {
    return null
  }
}

const extractFromPayload = (payload) => {
  if (!payload) return ""
  if (typeof payload === "string") {
    const parsed = parseJsonString(payload)
    if (parsed) return extractFromPayload(parsed)
    return payload.trim()
  }
  if (typeof payload === "object") {
    const direct =
      payload.error ||
      payload.message ||
      payload.detail ||
      payload.reason ||
      payload.title
    if (typeof direct === "string" && direct.trim()) return direct.trim()
  }
  return ""
}

export const getApiErrorMessage = (error, fallback = "Something went wrong.") => {
  const fromResponse = extractFromPayload(error?.response?.data)
  if (fromResponse) return fromResponse

  const fromMessage = extractFromPayload(error?.message)
  if (fromMessage) return fromMessage

  return fallback
}

